export default {
      id: "icon-heart-purple-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-heart-purple",
      toString: function () {
        return this.url;
      }
    }